import { Stack } from 'ui/stack';

import { Typography } from 'ui/typography';
import Button from 'components/partials/button/button';

import UserPage from 'containers/admin/users/user/user-page/user-page';

import { useCurrentUser } from 'hooks/api/use-current-user';

import Icons from 'assets/icons';
import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';

const Profile = (): React.JSX.Element => {
  const currentUser = useCurrentUser();

  return (
    <ResponsiveWrapper>
      <Stack
        direction="row"
        sx={{ alignItems: 'center', justifyContent: 'space-between' }}
      >
        <Typography
          data-testid="admin-profile-heading"
          variant="h1"
          sx={{ mt: 2 }}
        >
          Your Profile Details
        </Typography>
        <Button
          variant="reserve-text"
          size="lg"
          iconBefore={<Icons.LogOut aria-hidden="true" />}
          className="mt-4 pr-0"
          onClick={() => currentUser.signOut()}
          data-testid="logout-button"
        >
          Log Out
        </Button>
      </Stack>

      <UserPage isCurrentUserProfile={true} />
    </ResponsiveWrapper>
  );
};

export default Profile;
